import { CloseStatus, ConsultationsParamsKeys } from '@/modules/consultations'
import MSConsultations from '@/Services/MSConsultations'

type NpsPostPayloadDto = Parameters<typeof MSConsultations.msConsultations.createNps>[0]

export async function createNps(
  data: NpsPostPayloadDto,
  { customerHash, professionalHash }: { customerHash: string; professionalHash: string }
) {
  const { data: consultations } = await MSConsultations.msConsultations.listConsultations({
    [ConsultationsParamsKeys.FilterByCustomer]: customerHash,
    [ConsultationsParamsKeys.FilterByProfessional]: professionalHash,
    [ConsultationsParamsKeys.FilterByIsClosed]: CloseStatus.Open,
  })
  const consultation = consultations.data[0]
  if (!consultation) {
    throw new Error('No consultation found')
  }
  return MSConsultations.msConsultations.createNps({
    data: {
      ...data.data,
      relationships: {
        ...data.data.relationships,
        consultation: {
          data: {
            type: 'consultations',
            id: consultation.id,
          },
        },
      },
    },
  })
}
